import { render, staticRenderFns } from "./TheMobileTabBar.vue?vue&type=template&id=04de0a40&scoped=true"
import script from "./TheMobileTabBar.vue?vue&type=script&lang=js"
export * from "./TheMobileTabBar.vue?vue&type=script&lang=js"
import style0 from "./TheMobileTabBar.vue?vue&type=style&index=0&id=04de0a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de0a40",
  null
  
)

export default component.exports